import { render, staticRenderFns } from "./noticePanel.vue?vue&type=template&id=45d1602d"
import script from "./noticePanel.vue?vue&type=script&lang=js"
export * from "./noticePanel.vue?vue&type=script&lang=js"
import style0 from "./noticePanel.vue?vue&type=style&index=0&id=45d1602d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports